import getScrollTop from '../get-scroll-top';
import getNavbarsHeight from '../get-navbars-height';

const SWOOSH_HEIGHT_THRESHOLD_RATIO = 2 / 3;

// NOTE abstract, only instantiate subclasses
export default class SwooshableVideo {
  constructor(iframe) {
    this.iframe = iframe;
    this.$iframe = $(iframe);
    this.swooshed = false;
    this.iframeHeight = this.$iframe.height();
    this.iframeWidth = this.$iframe.width();
    this.$iframe.wrap('<div class="swooshable-video-holder"></div>');
    this.$videoHolder = this.$iframe.parent();
    this.$videoParentSpan = this.$videoHolder.parent();
    this.swooshOutPosition = {};

    // Set the padding -bottom of the containing span, otherwise it covers
    // proceding content
    this.$videoHolder.parent().css('padding-bottom', this.iframeHeight);

    this.$videoHolder.css({
      display: 'relative',
      height: this.iframeHeight,
      width: this.iframeWidth,
      background: '#999',
    });

    this.$iframe.css({
      'will-change': 'top, left, width, height',
      position: 'static',
      height: this.iframeHeight,
      width: this.iframeWidth,
      transform: 'translate3d(0px,0px,0px)',
    });

    this.originalPosition = {
      top: this.$iframe.offset().top - getScrollTop(),
      left: this.$iframe.offset().left,
      width: this.$iframe.css('width'),
      height: this.$iframe.css('height'),
    };
    this.lastScrollTop = getScrollTop();
  }

  onScroll() {
    const outsideThreshold = this.isVideoOutsideSwooshThreshold();
    const { playing } = this;
    const scrollTop = getScrollTop();
    const scrollTopDelta = this.lastScrollTop - scrollTop;

    this.lastScrollTop = scrollTop;

    this.originalPosition.top += scrollTopDelta;

    if (playing && !this.swooshed && outsideThreshold) {
      this.swoosher.swooshOut(this);
    } else if (this.swooshed && !outsideThreshold) {
      this.swoosher.swooshIn(this);
    }
  }

  isVideoOutsideSwooshThreshold() {
    const offset = this.$videoHolder.offset();
    const scrollTop = getScrollTop();

    if (!this.swooshed) {
      const top = offset.top - scrollTop + this.iframeHeight * (1 - SWOOSH_HEIGHT_THRESHOLD_RATIO);

      if (top < getNavbarsHeight()) return true;

      const bottom = offset.top - scrollTop + this.iframeHeight * SWOOSH_HEIGHT_THRESHOLD_RATIO;

      if (bottom > window.innerHeight) return true;
    } else {
      const top = offset.top - scrollTop + this.iframeHeight * (1 - SWOOSH_HEIGHT_THRESHOLD_RATIO);

      if (top < getNavbarsHeight()) return true;

      const bottom = offset.top - scrollTop + this.iframeHeight * SWOOSH_HEIGHT_THRESHOLD_RATIO;

      if (bottom > window.innerHeight) return true;
    }

    return false;
  }

  triggerSwooshInAnimation(duration) {
    // NOTE This does an initial animation of _duration_ ms to
    // this.originalPosition, constantly adjusting the end position during each
    // frame because the user is probably still scrolling (and
    // this.originalPosition will keep changing). Then it does a final 100ms
    // animation to this.originalPosition again because it's likely that there
    // is another position change in between the last frame and completion,
    // and this second animation minimises the jerk that occurs on the last
    // step - changing the frame's position to static, which locks it in place.

    this.swooshing = true;

    this.$iframe.animate(
      this.originalPosition,
      {
        duration,
        step: (now, tween) => {
          if (['top', 'right', 'bottom', 'left'].indexOf(tween.prop) === -1) return;

          tween.end = this.originalPosition[tween.prop];
        },
        complete: () => {
          this.$iframe.animate(
            this.originalPosition,
            {
              duration: 200,
              complete: () => {
                this.$iframe.css({
                  position: 'static',
                });
                this.swooshing = false;
              },
            },
          );
        },
      },
    );
  }

  /* eslint-disable class-methods-use-this */
  get playing() {
    throw String('virtual');
  }
  /* eslint-enable class-methods-use-this */
}
